var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPencilIcon = function SvgPencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M9.453 2.744l3.805 3.805-8.508 8.508-4.75.945.945-4.75 8.508-8.508zM15.211.791a2.683 2.683 0 010 3.805l-1.242 1.25-3.805-3.805 1.242-1.25a2.683 2.683 0 013.805 0z"
  })));
};
export default SvgPencilIcon;